<template>
  <div class="main-content">
    <div class="card" v-if="records">
      <div class="card-body">
        <table class="table table-sm">
          <thead>
          <tr>
            <th></th>
            <th>Время</th>
            <th>Ответ</th>
            <th>Кто звонил</th>
            <th>Набранный номер</th>
            <th>Длительность</th>
            <th>CODE</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(record, index, count) in records" :key="index">
            <td>{{count != undefined ? count+1 : index+1}}</td>
            <td>{{record.start}}</td>
            <td>{{record.answer}}</td>
            <td>{{record.from_number}}</td>
            <td>{{record.to_number}}</td>
            <td>{{getDuration(record)}}</td>
            <td>{{record.disconnect_reason}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card" v-if="filteredMissed">
      <div class="card-body">
        <h5>Пропушенные (отфильтрованные)</h5>
        <div class="mb-2">
          <label :for="`ch_i`">
            <input @change="updateMissed" v-model="showIgnored" type="checkbox" name="ignored" :id="`ch_i`">
            Показать скрытые
          </label>
        </div>
        <table class="table table-sm">
          <thead>
          <tr>
            <th width="50"></th>
            <th width="140">Телефон</th>
            <th width="300">Клиент</th>
            <th width="300">Звонки / Перезвоны</th>
            <th>Комментарий</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(records, count) in filteredMissed" vif="groupCalls(records)[0]">
            <td>{{count + 1}}</td>
            <td>{{records[0].from_number}}</td>
            <td>
              <template v-if="clients[getFirstRecord(records).from_number]">
                <p class="mb-2" v-if="clients[getFirstRecord(records).from_number]">{{clients[getFirstRecord(records).from_number].name}}</p>
                <div class="flex flex-wrap orders_block">
                  <div class="orderInfo" v-for="order in getClientOrders(clients[getFirstRecord(records).from_number].orders)">
                    <p>{{order.siteTitle}} <span class="text-muted">({{order.id}})</span></p>
                    <p class="text-muted">{{order.statusTitle}}</p>
                    <p class="text-muted">{{order.report_date}}</p>
                  </div>
                </div>
              </template>
              <template v-else>
                <p class="mb-2">Клиент не найден в базе</p>
              </template>
            </td>
            <td>
              <div class="flex" v-for="(calls, number) in groupCalls(records)">
                <div>
                  <vue-ladda @click="makeCallBack(calls[0])" button-class="btn btn-sm btn-primary mr-5" data-style="zoom-in"
                             :loading="loading"><i class="icon-fa icon-fa-phone-square"></i>
                  </vue-ladda>
                </div>
                <div>
                  <template v-if="phoneTitles[number]">
                    <div class="phone_info">
                      <p>{{phoneTitles[number]}}</p>
                      <p class="text-muted">{{number}} ({{calls.length}})</p>
                    </div>
                  </template>
                  <template v-else>
                    {{number}} ({{calls.length}})
                  </template>
                  <p class="text-muted font-10">{{calls[calls.length-1].start}}</p>
                </div>
                <div>
                  <div v-if="getCallBacks(callBack[records[0].to_number], number)" class="callBacks_info">
                    <p class="font-10" v-for="(call, index) in getCallBacks(callBack[records[0].to_number], number)">{{call.start}}</p>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <template v-for="(calls, number) in groupCalls(records)">
                <form action="" @submit.prevent="saveComment($event, calls[0])">
                  <div class="phones_comments_block" v-html="printComments(calls[0])"></div>
                  <div class="input-group">
                    <input type="text" placeholder="Комментарий" class="form-control" name="commentText">
                    <div class="input-group-append">
                      <button class="btn btn-success" name="submitBtn" type="submit"><i class="icon-fa icon-fa-save"></i></button>
                    </div>
                  </div>
                  <div>
                    <label :for="`ch_${calls[0].id}`">
<!--                      {{records[0].to_number, ignored[records[0].to_number]}}-->
                      <input v-model="ignored[records[0].from_number][number]" type="checkbox" name="ignored" :id="`ch_${calls[0].id}`">
                      Скрыть
                    </label>
                  </div>
                </form>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>


<script>

  import api from '@/api'
  import moment from 'moment'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'

  export default {
    components: {
      moment,
      VueLadda,
    },
    data() {
      return {
        'ignored': {},
        'loading': false,
        'managers': {},
        'phoneTitles': {},
        'clients': {},
        'filteredMissed': null,
        'showIgnored': false,
        'records': null,
        'commentsRecords': {},
        'callBack': null,
        'missed': null,
        'allRecords': null
      }
    },
    mounted() {
      this.getCalls();
    },
    methods: {
      getClientOrders(objectOrders){
        let arr = [];
        Object.keys(objectOrders).forEach((k) =>{
          arr.push(objectOrders[k]);
        })
        return arr;
      },
      hasActiveCalls(records){
        let visible = false;
        if (typeof records == 'object'){
          Object.keys(records).forEach((k) => {
            if (!this.commentsRecords[records[k].from_number] || this.commentsRecords[records[k].from_number] && !this.commentsRecords[records[k].from_number][records[k].to_number]) {
              visible = true;
              return;
            }
            if (!this.commentsRecords[records[k].from_number][records[k].to_number].ignored) visible = true;
          });
        }else {
          records.forEach((r) => {
            if (!this.commentsRecords[r.from_number] || this.commentsRecords[r.from_number] && !this.commentsRecords[r.from_number][r.to_number]) {
              visible = true;
              return;
            }
            if (!this.commentsRecords[r.from_number][r.to_number].ignored) visible = true;
          });
        }
        return visible;
      },
      getCallBacks(list, phoneNum) {
        let arr = [];
        if (!list) {
          return arr;
        }
        if (typeof list == 'object') {
          Object.keys(list).forEach((k) => {
            if (list[k].from_number == phoneNum) arr.push(list[k]);
          })
        } else {
          list.forEach((r) => {
            if (r.from_number == phoneNum) arr.push(r);
          })
        }
        return arr;
      },
      groupCalls(records) {
        let group = {};
        if (typeof records == 'object') {
          Object.keys(records).forEach((k) => {
            if (!group[records[k].to_number]) group[records[k].to_number] = [];
            group[records[k].to_number].push({
              id: records[k].id,
              start: records[k].start,
              to_number: records[k].to_number,
              from_number: records[k].from_number,
              site_id: records[k].site_id
            });
          })
        } else {
          records.forEach((r) => {
            if (!group[r.to_number]) group[r.to_number] = [];
            group[r.to_number].push({
              start: r.start,
              to_number: r.to_number,
              from_number: r.from_number,
              site_id: r.site_id
            });
          })
        }
        return group;
      },
      getFirstRecord(records) {
        if (typeof records === 'object') {
          return records[Object.keys(records)[0]];
        }
        return records[0];
      },
      sortedCalls(list) {
        return _.orderBy(list, 'start', 'desc');
      },
      moment: function (date, format) {
        if (!date) return;
        return moment(date).format(format);
      },
      async makeCallBack(record) {
        // record.loading = true;
        let {data} = await api.post('/phoneCalls/makeCallBack', record);
        if (data.success) {
          this.Toast.fire({
            type: 'success',
            title: data.response + ' - Отправленно'
          })
        } else {
          this.Toast.fire({
            type: 'warning',
            title: data.message || 'Ошибка'
          })
        }
        // record.loading = false;
      },
      updateMissed() {
        console.log('update');
        if (this.showIgnored) {
          this.filteredMissed = {...this.missed};
        } else {
          let obj = {};
          Object.keys(this.missed).forEach((ph) => {
            if (!ph) return;
            if (this.hasActiveCalls(this.missed[ph])){
              obj[ph] = this.missed[ph];
            }
          });
          this.filteredMissed = obj;
          // . hasActiveCalls(records)
          // this.filteredMissed = Object.values(this.missed).reduce((accum, comment) => {
          //   if (!comment.ignored) accum.push(comment);
          //   return accum;
          // }, []);
          // this.filteredMissed = {...this.missed};

        }
        this.filteredMissed = _.orderBy(this.filteredMissed, '[0].start', 'desc');
      },
      printComments(record) {
        if (!this.commentsRecords[record.from_number] || this.commentsRecords[record.from_number] && !this.commentsRecords[record.from_number][record.to_number]) return;
        let text = '';
        this.commentsRecords[record.from_number][record.to_number].records.forEach((r) => {
          text += '<p>' + r.comment + ' <span class="text-muted">' + r.created_at + '</span> (' + (r.user_id ? (this.managers[r.user_id] || 'ID:' + r.user_id) : 'Я') + ')</p>';
        });
        return text;
      },
      async saveComment(form, record) {
        form.target.submitBtn.disabled = true;
        let {data} = await api.post('/phoneCalls/addComment', {
          // from_number: phoneNum,
          from_number: record.from_number,
          to_number: record.to_number,
          text: form.target.commentText.value,
          ignore: form.target.ignored.checked
        });
        if (data.success) {

          if (!this.commentsRecords[record.from_number]) {
            this.$set(this.commentsRecords, record.from_number, {});
            this.commentsRecords[record.from_number][record.to_number] = {records: []};
          }
          if (!this.commentsRecords[record.from_number][record.to_number]){
            this.commentsRecords[record.from_number][record.to_number] = {records: []};
          }
          if (form.target.commentText.value)
            this.commentsRecords[record.from_number][record.to_number].records.push({created_at: 'сейчас', comment: form.target.commentText.value})
          form.target.commentText.value = '';

          this.commentsRecords[record.from_number][record.to_number].ignored = form.target.ignored.checked;
          // this.ignored[record.from_number][record.to_number] = form.target.ignored.checked;
          this.updateMissed();
          this.commentsRecords = {...this.commentsRecords}

          this.Toast.fire({
            type: 'success',
            title: 'Сохранено'
          })
        } else {
          this.Toast.fire({
            type: 'warning',
            title: 'Ошибка'
          })
        }
        form.target.submitBtn.disabled = false;
      },
      getDuration(record) {
        if (record.answer) {
          return moment.utc(moment(record.finish, "YYYY-MM-DD HH:mm:ss").diff(moment(record.answer, "YYYY-MM-DD HH:mm:ss"))).format("mm:ss")
        }
        return;
      },
      async getCalls() {
        let {data} = await api.index('/phoneCalls/getMissed');
        this.phoneTitles = data.phoneTitles;
        this.clients = data.clients;
        this.managers = data.managers;
        this.callBack = data.callBack;
        let ignored = {};

        let myPromise = new Promise(async (resolve, reject) => {
          Object.keys(data.commRecords).forEach((phoneNum) => {
            // data.clearedMissed[phoneNum].ignored = data.commRecords[phoneNum].ignored;
          });
          Object.keys(data.clearedMissed).forEach((phoneNum) => {
            // data.clearedMissed[phoneNum].loading = false;
          });
          Object.keys(data.clearedMissed).forEach((phoneNum) => {
            data.clearedMissed[phoneNum].forEach((r) => {
              if (!ignored[phoneNum]) ignored[phoneNum] = {};
              if (data.commRecords[phoneNum] && data.commRecords[phoneNum][r.to_number]){
                ignored[phoneNum][r.to_number] = data.commRecords[phoneNum][r.to_number].ignored;
              }else{
                ignored[phoneNum][r.to_number] = 0;
              }
            })
          });
          resolve(data);
        });
        const updatedData = await myPromise;
        this.ignored = ignored;
        this.commentsRecords = data.commRecords;
        this.missed = updatedData.clearedMissed;
        this.updateMissed();

      }
    }
  }

</script>

<style scoped>
  .callBacks_info {
    margin-left: 5px;
    padding-left: 5px;
    border-left: 1px solid lightgray;
  }

  .mr-5 {
    margin-right: 5px !important;
  }

  .font-10 {
    font-size: 10px;
    margin-bottom: 2px;
  }

  .v-align-top {
    vertical-align: top;
  }

  .orders_block {
    max-width: 400px;
  }

  .orderInfo {
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px;
    border: 1px solid gray;
  }

  .orderInfo .text-muted {
    font-size: 10px;
  }

  .orderInfo p {
    margin-bottom: 1px;
  }

  .phone_info p {
    margin-bottom: 2px;
  }

  i {
    text-align: center;
  }

</style>
<style>
  .phones_comments_block p {
    padding: 1px 10px;
    background-color: #e7f8fe;
    margin-bottom: 2px;
  }

  .phones_comments_block span {
    font-size: 10px;
  }
</style>
